import { ArrowLeft } from "lucide-react";
import { useTranslation } from "react-i18next";
import { PrimaryButton, TextButton } from "./ui/buttons";

interface StepFooterProps {
  primaryLabel: string;
  onPrimary?: () => void;
  primaryDisabled?: boolean;
  loading?: boolean;
  /** Why the primary action is not available yet; shown under the buttons. */
  hint?: string | null;
  onBack?: () => void;
  backLabel?: string;
  /** "submit" when the footer sits inside a form that owns the action. */
  primaryType?: "button" | "submit";
}

export function StepFooter({
  primaryLabel,
  onPrimary,
  primaryDisabled = false,
  loading = false,
  hint,
  onBack,
  backLabel,
  primaryType = "button",
}: StepFooterProps) {
  const { t } = useTranslation("onboarding");
  return (
    <div className="mt-8 flex flex-col gap-3 border-t border-g-line-row pt-6">
      <div className="flex flex-wrap items-center justify-between gap-3">
        {onBack ? (
          <TextButton onClick={onBack} disabled={loading} className="-ml-3">
            <ArrowLeft className="h-4 w-4" aria-hidden="true" />
            {backLabel ?? t("meta.back")}
          </TextButton>
        ) : (
          <span />
        )}
        <PrimaryButton
          type={primaryType}
          onClick={primaryType === "button" ? onPrimary : undefined}
          disabled={primaryDisabled}
          loading={loading}
        >
          {primaryLabel}
        </PrimaryButton>
      </div>
      {hint ? <p className="text-right text-[12.5px] text-g-ink-500">{hint}</p> : null}
    </div>
  );
}
